var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdificio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "law-building-solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 36,
    width: 38,
    height: 4,
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,42H4a2,2,0,0,0-2,2v2H46V44A2,2,0,0,0,44,42Z",
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 4,
    height: 16,
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 4,
    height: 16,
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 18,
    width: 4,
    height: 16,
    fill: "#3498db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9,11.4,24,2,3.1,11.4A2.1,2.1,0,0,0,2,13.2V14a2,2,0,0,0,2,2H44a2,2,0,0,0,2-2v-.8A2.1,2.1,0,0,0,44.9,11.4Z",
    fill: "#3498db"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdificio);
export default __webpack_public_path__ + "static/media/edificio.6137c265845c061cf7d225cb77b7b500.svg";
export { ForwardRef as ReactComponent };